import { useCallback } from "react";

import * as MutationRepository from "@/components/features/settings/payment-credit/repository/mutation";

type Props = {
	hotelID: string;
};

export const useUpdatePaymentCredit = ({ hotelID }: Props) => {
	const { onUpdatePaymentCredit: _onUpdatePaymentCredit } = MutationRepository.usePaymentCreditMutation();
	const onUpdatePaymentCredit = useCallback(
		async ({ paymentToken }: { paymentToken: string }) => {
			const input = { hotelID, paymentToken };
			return await _onUpdatePaymentCredit(input);
		},
		[_onUpdatePaymentCredit, hotelID],
	);

	return {
		onUpdatePaymentCredit,
	};
};
